<template>
  <div>
    <!-- загрузка документов на статусе waitforcoownersdata -->
    <v-row v-if="showFlTab">
      <v-col cols="4">
        <v-tabs vertical v-model="tab">
          <v-tab> Информация </v-tab>
          <p class="d-none d-sm-block font font--action-small-2 pl-6 pt-4 mb-2">Физ. лица</p>
          <v-tab v-for="person in fl" :key="person.name" class="text-subtitle-2">
            <ApprovedIcon :person="person" /> {{ person.name }}
          </v-tab>
        </v-tabs>
        <div class="ma-6 d-flex flex-column align-items-start" style="position: fixed; bottom: 0">
          <v-btn v-if="allFilesLoaded" color="warning" class="mb-2" @click="sendFiles">Отправить документы</v-btn>
        </div>
      </v-col>
      <v-col cols="8">
        <v-tabs-items v-model="tab">
          <v-tab-item class="py-2 pr-4 pl-0">
            <BidDetailsInfo />
          </v-tab-item>
          <v-tab-item v-for="(person, i) in fl" :key="person.name" class="py-2 pr-4 pl-0">
            <BidFLTab :selectedPerson="i" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- FIX !showFlTab -->
    <template v-if="!showFlTab">
      <div class="side-panel-right-field" v-if="details">
        <div v-if="showMsg" class="note d-flex font font--note font--color_note">
          <div style="margin-right: 10px">
            <v-icon size="18px" class="font--color_warning">{{ "mdi-information-outline" }}</v-icon>
          </div>
          <div v-if="details.state === 'waitforuploaddocs'">
            <div class="mb-3">
              Проверка компании завершена. Теперь необходимо загрузить паспортные данные руководителя и владельцев
              компании.
            </div>
            <v-btn color="primary" @click="openBidLoadDoc">Загрузить документы</v-btn>
          </div>
          <div v-else>
            {{ statusDescription }}
          </div>
        </div>
        <BidDetailsInfo />
        <div v-if="details.files">
          <h3 class="font font--h3">Вложения</h3>
        </div>
      </div>
    </template>

    <BidMeetingPlace v-if="showReserveMeeting" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import BidDetailsInfo from "@/components/bids/BidDetailsInfo";
import BidFLTab from "@/components/bids/BidFLTab";
import BidMeetingPlace from "@/components/bids/BidMeetingPlace";
import ApprovedIcon from "@/components/common/ApprovedIcon.vue";

export default {
  name: "BidDetails",

  components: { BidDetailsInfo, BidFLTab, ApprovedIcon, BidMeetingPlace },

  props: {
    closePanel: {
      type: Boolean,
    },
  },

  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    ...mapState("bid", ["statuses", "details"]),
    ...mapGetters("bid", ["fl"]),
    ...mapGetters("profile", ["canMeetingPlace"]),

    statusDescription() {
      return this.statuses[this.details.state] ? this.statuses[this.details.state].description : null;
    },
    showMsg() {
      return this.details.state === "waitforuploaddocs" || !!this.statusDescription;
    },
    showFlTab() {
      return this.details && this.details.state == "waitforcoownersdata" && this.fl && this.fl.length;
    },
    allFilesLoaded() { // FIXME:
      const notSended = this.fl.some((p) => p.sended === false);

      const allFlsFilesLoaded = this.fl.every(fl => {
        return fl.attachments?.every(attachment => {
          const isRequired = attachment.properties?.is_required ?? 0;
          if (isRequired) {
            return (attachment.files?.length ?? 0) !== 0;
          }

          return true;
        });
      });

      return allFlsFilesLoaded && this.details.state == "waitforcoownersdata" && notSended;
    },
    showReserveMeeting() {
      return this.details?.template?.reserve_meeting === 1;
    }
  },

  methods: {
    ...mapActions("bid", ["bidTouch"]),
    openBidLoadDoc() {
      this.$store.commit("bid/set", { type: "showBidLoadDocs", value: true });
    },
    async sendFiles() {
      await this.bidTouch();

      this.$store.commit("bid/set", { type: "showBidDetails", value: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  padding: 14px 20px;
  background: #fcf2ce;
  border-radius: 3px;
  margin-bottom: 16px;
  .font--color_warning {
    color: #d2aa0f;
  }
}
.bid-details {
  background-color: #f5f5f6;
  & > div > div:first-child {
    flex-basis: 200px;

    @media (max-width: 500px) {
      flex-basis: 90px;
      margin-right: 24px;
      flex-shrink: 0;
    }
  }

  & > div > div:last-child {
    word-wrap: break-word;
    word-break: break-word;
  }
}
</style>
